import { useBreakpointValue } from '@chakra-ui/react';

const isMobile = (): boolean => useBreakpointValue({ base: true, md: false });

/**
 * Whether the header should use the compact menu. Later than isMobile: from
 * md to lg the full navigation (About Us, Class Booking, Events, My Account,
 * the basket and Log Out) is wider than the screen, so on a tablet or a small
 * laptop window Log Out and the basket were pushed off the right edge.
 */
export const useCompactNav = (): boolean => useBreakpointValue({ base: true, lg: false });

export default isMobile;
